'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const checkAnimation = styled.keyframes `
  0% {
    top: -7px;
    right: -7px;
    bottom: -7px;
    left: -7px;
    opacity: 15%;
  }

  75%{
    opacity: 15%;
  }

  100% {
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    opacity: 0;
  }
`;
const uncheckAnimation = styled.keyframes `
  0% {
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    opacity: 15%;
  }

  75%{
    opacity: 15%;
  }

  100% {
    top: -7px;
    right: -7px;
    bottom: -7px;
    left: -7px;
    opacity: 0;
  }
`;
const indeterminateAnimation = styled.keyframes `
  0% {
    top: -7px;
    right: -7px;
    bottom: -7px;
    left: -7px;
    opacity: 15%;
  }

  75%{
    opacity: 15%;
  }

  100% {
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    opacity: 0;
  }
`;
const Container = styled__default.default.label `
  display: inline-block;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  &[aria-disabled='true'] {
    cursor: default;
  }
  &:focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.designTokens.radioFocusShadow};
  }
`;
const Label = styled__default.default.span `
  display: inline-block;
  vertical-align: middle;
  color: ${({ theme }) => theme.palette.darkGrey};
  font-family: ${({ theme }) => theme.typography.fontFamily.regular};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  margin-left: ${({ theme }) => theme.space.component.x.s};
  user-select: none;
  font-weight: 500;
`;
const Box = styled__default.default.div `
  position: relative;
  display: inline-block;
  height: 16px;
  width: 16px;
  border: solid 1px ${({ theme }) => theme.palette.grey500};
  border-radius: 3px;
  background-color: ${({ theme }) => theme.palette.white};
  margin: ${({ theme }) => theme.space.component.x.xs};
  vertical-align: middle;
  box-sizing: border-box;
  &:hover {
    border-color: ${({ theme }) => theme.palette.grey500};
  }
  &:after {
    content: '';
    border-radius: 3px;
    position: absolute;
    background-color: ${({ theme }) => theme.palette.blue400};
    z-index: -1;
  }
`;
const BoxPlaceholder = styled__default.default.div `
  position: relative;
  display: inline-block;
  height: 16px;
  width: 0;
  margin: ${({ theme }) => theme.space.component.x.xs} 0;
  vertical-align: middle;
  box-sizing: border-box;
`;
const Input = styled__default.default.input `
  display: none;
  &:checked {
    ~ ${Box} {
      background-color: ${({ theme, crossMode }) => (crossMode ? theme.palette.red400 : theme.palette.blue400)};
      border-color: ${({ theme, crossMode }) => (crossMode ? theme.palette.red400 : theme.palette.blue400)};

      &:before {
        ${({ crossMode }) => crossMode &&
    styled.css `
            content: '×';
            position: absolute;
            top: -1px; // border size
            text-align: center;
            width: 100%;
            color: ${({ theme }) => theme.palette.white};
            font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
            font-size: ${({ theme }) => theme.typography.fontSize.xl};
            line-height: ${({ theme }) => theme.typography.lineHeight.xs};
          `}
        ${({ crossMode }) => !crossMode &&
    styled.css `
            content: '';
            transform: rotate(45deg);
            border-bottom: 2px solid ${({ theme }) => theme.palette.white};
            border-right: 2px solid ${({ theme }) => theme.palette.white};
            margin: 1px 5px;
            width: 3px;
            height: 8px;
          `}
        display: block;
        box-sizing: content-box;
      }
      &:after {
        animation: ${checkAnimation} 0.15s ease-out;
      }
    }
  }
  &:not(:checked) {
    ~ ${Box} {
      &:after {
        animation: ${uncheckAnimation} 0.15s ease-out;
      }
    }
  }
  &:indeterminate {
    ~ ${Box} {
      background-color: ${({ theme }) => theme.palette.blue400};
      border-color: ${({ theme }) => theme.palette.blue400};
      &:before {
        content: '';
        display: block;
        width: 12px;
        height: 2px;
        margin: 6px 1px;
        border-radius: 3px;
        background-color: ${({ theme }) => theme.palette.white};
        transform: none;
      }
      &:after {
        animation: ${indeterminateAnimation} 0.15s ease-out;
      }
    }
  }
  &:disabled {
    ~ ${Box} {
      border-color: ${({ theme }) => theme.palette.grey400};
    }
  }
  &:disabled&:indeterminate,
  &:disabled&:checked {
    ~ ${Box} {
      border-color: ${({ theme }) => theme.palette.grey400};
      background-color: ${({ theme }) => theme.palette.grey400};
    }
  }
`;
const Styled = {
    Container,
    Input,
    Box,
    BoxPlaceholder,
    Label,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
